import React from "react";
import BasicModal from "../../core/BaseComponents/Modal";
import deleteImg from '../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";

function DeleteDefaultWelcomeMessage(props) {
  const row = props?.isPublishUnPublishDeletedRef?.current?.isPublishUnPublishDeletedModalData?.row;
  const isHotelLevel = row?.isHotelLevel;
  const roomType = row?.roomType || "";
  const confirmPhrase = isHotelLevel
    ? `Delete Hotel Welcome Message`
    : `Delete ${roomType} Welcome Message`;

  return (
    <BasicModal
      popupOpen={props?.deletePublishUnPublishPopUp}
      bodyMessage={<>
        <img src={deleteImg} alt="approve" className="w-40px" />
        <div className="delete-hotel mb-3">{props?.isPublishUnPublishDeletedRef?.current?.isPublishUnPublishDeletedModalData ?
          <div className="confirm-delete-hotel">
            <p>Do you really want to delete the welcome message for "<b>{roomType}</b>"?</p>
            <p className="warning"><IoMdWarning /> Warning</p>
            <p>This welcome message will be permanently deleted and cannot be undone.</p>
            <p className="mt-3">To confirm deletion, type "{confirmPhrase}"</p>
            <div className="form-group-hotel mt-3">
              <div className="floating-label">
                <input
                  id="deleteDefaultWelcomeMessage"
                  placeholder=""
                  onChange={(e) => props?.setConfirmDeletePublishUnPublish(e.target.value)}
                />
                <label htmlFor="deleteDefaultWelcomeMessage">Delete Welcome Message</label>
              </div>
              {(props?.confirmDeletePublishUnPublish === "" && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter {confirmPhrase}</small></p>
              ) : (props?.confirmDeletePublishUnPublish !== confirmPhrase && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter {confirmPhrase}</small></p>
              ) : ""
              }
            </div>
          </div> :
          props?.isPublishUnPublishDeletedRef?.current?.userConformationModalData?.successMessage}</div>
      </>
      }
      footer={
        props?.isPublishUnPublishDeletedRef?.current?.isPublishUnPublishDeletedModalData ?
          {
            primaryButton: {
              buttonName: "Cancel",
              action: props?.popupCloseHandler
            },
            secondaryButton: {
              buttonName: "Delete",
              action: props?.deletePublishUnPublishHandler
            }
          } : {
            secondaryButton: {
              buttonName: "OK",
              action: props?.popupCloseHandler
            }
          }
      }
    />
  );
}

export default DeleteDefaultWelcomeMessage;
